<template>
  <component
    :is="element"
    class="info-tooltip"
    @mouseenter="showInfo = true"
    @mouseleave="showInfo = false"
  >
    <Icon icon="info" class="info-icon" />
    <transition name="fade">
      <Tooltip v-if="showInfo" :text="text" :minWidth="tooltipMinWidth" />
    </transition>
  </component>
</template>

<script>
/**
 * Ícone de ajuda com tooltip informativa
 */
import Tooltip from '../elements/Tooltip'

export default {
  name: 'InfoTooltip',
  components: {
    Tooltip
  },
  props: {
    /** elemento html da tooltip */
    element: {
      type: String,
      default: 'span'
    },
    /** conteúdo de texto */
    text: {
      type: String,
      default: 'Texto informativo'
    },
    /** largura mínima da tooltip */
    tooltipMinWidth: {
      type: [Number, String],
      default: 150
    }
  },
  data() {
    return {
      showInfo: false
    }
  }
}
</script>

<style lang="scss" scoped>
.info-tooltip {
  display: inline-flex;
  align-items: center;
  position: relative;
  width: 12px;
  height: 12px;

  .info-icon {
    width: 100%;
    height: 100%;
    color: $gray-dark;
    transition: color $color-anim linear;

    &:hover {
      color: $blue;
    }
  }
}
</style>
